<!--
 * @Description:
 * @Autor: gxd
 * @Date: 2020-12-02 14:47:45
 * @LastEditors: gxd
 * @LastEditTime: 2020-12-07 15:35:58
-->
<template>
  <div class="bottom-box">
    <div v-if="isShowReviewCalendar" class="invitation-show-upload-calendar" @click="showReviewCalendar">查看审核记录 ></div>
    <div class="invitation-upload-bottom">
      <p class="invitation-upload-bottom-title">截图说明</p>
      <p class="invitation-upload-bottom-content">①打开“微信”-“朋友圈”，找到自己发布的海报后截图</p>
      <p class="invitation-upload-bottom-content">②海报需至少保留2小时且不能设置分组或私密</p>
      <p class="invitation-upload-bottom-content-red">③转发海报需加邀请语，制作专属海报需上传孩子的照片</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewUploadBottom',
  data () {
    return {
      isShowReviewCalendar: true
    }
  },
  methods: {
    // 展示审核日历/记录
    showReviewCalendar () {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '截图审核',
          element_action: 'click',
          element_value: '截图审核-补审入口-查看审核记录-按钮-点击'
        }
      })
      this.$router.push({ name: 'uploadCalendar' })
      // const route = { name: 'address' }
      // this.$router.push(route)
    }
  }
}
</script>

<style lang='less' scoped>
.bottom-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .invitation-show-upload-calendar {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 242px;
    height: 30px;
    margin-top: 10px;
    font-weight: 400;
    color: #e02727;
    background: #fff;
    border: #fd422f 1px solid;
    border-radius: 15px;
  }

  .invitation-upload-bottom {
    margin-left: 10px;
    margin-top: 12px;

    .invitation-upload-bottom-title {
      margin-bottom: 3px;
      font-size: 15px;
      color: #e02727;
    }

    .invitation-upload-bottom-content {
      font-size: 11px;
      font-weight: 400;
      line-height: 20px;
      color: #333;
    }

    .invitation-upload-bottom-content-red {
      font-size: 11px;
      font-weight: 400;
      color: #e02727;
    }
  }
}

</style>
